import { ModalHeader, useDeviceType } from '@braskai/ui-kit';

import { Stack } from '@mui/material';

import { ModalHeaderProps } from '../../lib/types';

const { Container, Subtitle, Title } = ModalHeader;

export const ModalHeaderSecondary = ({
  title,
  maxLinesSubtitle,
  maxLinesTitle,
  subtitle,
  ...props
}: ModalHeaderProps) => {
  const { isMobile } = useDeviceType();

  return (
    <Container {...props}>
      <Stack gap={4}>
        <Title maxLines={maxLinesTitle} mr={40} variant={isMobile ? 'title-4-md' : 'title-3-md'}>
          {title}
        </Title>
        {subtitle && (
          <Subtitle color="grey.700" maxLines={maxLinesSubtitle} variant="body-2">
            {subtitle}
          </Subtitle>
        )}
      </Stack>
    </Container>
  );
};
